import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServerCustomCss, ClientCustomCss, ServerAppCustomCss, ClientAppsCustomCss } from './customCss'
import { LifeCycle, HeadContentProviderSymbol } from '@wix/thunderbolt-symbols'
import { CustomCssAPISymbol } from './symbols'
import { CustomCssApi } from './customCssApi'
import { CustomCssHeadContentProvider } from './CustomCssHeadContentProvider'

export { CustomCssAPISymbol, CustomCssDsAPISymbol } from './symbols'
export type { ICustomCssDsAPI } from './types'

export const site: ContainerModuleLoader = (bind) => {
	bind(CustomCssAPISymbol).to(CustomCssApi)
	if (!process.env.browser) {
		bind(LifeCycle.AppWillMountHandler).to(ServerCustomCss)
		bind(HeadContentProviderSymbol).to(CustomCssHeadContentProvider)
	} else {
		bind(LifeCycle.AppWillMountHandler).to(ClientCustomCss)
	}
}

export const page: ContainerModuleLoader = (bind) => {
	if (!process.env.browser) {
		bind(LifeCycle.PageWillMountHandler).to(ServerAppCustomCss)
	} else {
		bind(LifeCycle.PageWillMountHandler).to(ClientAppsCustomCss)
	}
}
